import type { ComponentProps, MouseEvent } from 'react';
import { REGISTER_URL } from '../constants/links';
import { trackRegisterClick } from '../lib/analytics';

type RegisterLinkProps = Omit<ComponentProps<'a'>, 'href'> & {
  source: string;
  label?: string;
};

export default function RegisterLink({
  source,
  label,
  onClick,
  children,
  ...props
}: RegisterLinkProps) {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    trackRegisterClick({ source, label });
    onClick?.(event);
  };

  return (
    <a href={REGISTER_URL} onClick={handleClick} {...props}>
      {children}
    </a>
  );
}
